"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _max = _interopRequireDefault(require("lodash/max"));

var _flatten = _interopRequireDefault(require("lodash/flatten"));

var _reactVis = require("react-vis");

var _chartStyles = require("./chartStyles");

var _chartUtils = require("../../chartUtils");

var _helpers = require("../../helpers");

var _colors = require("../../constants/colors");

var _Styles = require("./Styles");

var _ScrollableXYPlot = _interopRequireDefault(require("./ScrollableXYPlot"));

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var crosshairStyles = {
  line: {
    background: _colors.FADED_GREY,
    width: '0.5px'
  },
  box: {
    display: 'none'
  }
};

var CustomerMonthlyYOYChart = function CustomerMonthlyYOYChart(_ref) {
  var lineColors = _ref.lineColors,
      today = _ref.today,
      renderHint = _ref.renderHint,
      siteProductionMonthlyReadingsByYear = _ref.siteProductionMonthlyReadingsByYear,
      zone = _ref.zone,
      mobileWidth = _ref.mobileWidth,
      desktopWidth = _ref.desktopWidth;

  var beginningOfYear = _luxon.DateTime.fromISO(today, {
    zone: zone
  }).startOf('year');

  var endOfYear = _luxon.DateTime.fromISO(today, {
    zone: zone
  }).endOf('year');

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      nearestDataPoint = _useState2[0],
      setNearestDataPoint = _useState2[1];

  var thisYear = parseInt(new Date().getFullYear(), 10);
  var readingsYOY = Object.keys(siteProductionMonthlyReadingsByYear).reduce(function (readingDictYOY, year) {
    var yearRow = siteProductionMonthlyReadingsByYear[year];
    readingDictYOY[year] = yearRow.reduce(function (dictionary, reading) {
      var id = _luxon.DateTime.fromISO(reading.readingEndTimeLocal, {
        zone: zone
      }).set({
        year: thisYear
      }).endOf('month').toISODate();

      dictionary[id] = reading;
      return dictionary;
    }, {});
    return readingDictYOY;
  }, {});
  var lastDayOfEachMonth = (0, _helpers.getDatesBetween)({
    startDate: beginningOfYear,
    endDate: endOfYear
  }, {
    hour: 23,
    minute: 59,
    second: 59
  }, 'months');
  var coordinateLinesByYear = Object.keys(siteProductionMonthlyReadingsByYear).reduce(function (yearlyDict, year) {
    yearlyDict[year] = lastDayOfEachMonth.map(function (dt) {
      var isoDate = dt.endOf('month').toISODate();
      var y = readingsYOY[year][isoDate] && (0, _chartUtils.isNumeric)(readingsYOY[year][isoDate].deliveredKwh) ? Number(readingsYOY[year][isoDate].deliveredKwh) : 0;
      return {
        x: isoDate,
        y: y,
        y0: 0
      };
    });
    return yearlyDict;
  }, {});
  var hoverCoordinates = lastDayOfEachMonth.map(function (dt) {
    var isoDate = dt.endOf('month').toISODate();
    return {
      x: isoDate,
      y: 0,
      y0: 0
    };
  });
  var maxValue = (0, _max["default"])((0, _flatten["default"])(Object.values(coordinateLinesByYear)).map(function (c) {
    return c.y;
  }));
  var hasNoData = Object.keys((0, _flatten["default"])(Object.values(readingsYOY))).length === 0;
  var roundedMaxValue = Math.max(Math.ceil(maxValue / 5) * 5, 5);
  var tickValues = (0, _helpers.getTickValuesFromMax)(roundedMaxValue);
  var hintCoordinate = null;
  var filteredNearestPoints = nearestDataPoint && nearestDataPoint.length > 0 ? nearestDataPoint.filter(Boolean) : [];

  if (filteredNearestPoints.length > 0) {
    var hintRecord = filteredNearestPoints.reduce(function (prev, current) {
      return parseFloat(prev.deliveredKwh) > parseFloat(current.deliveredKwh) ? prev : current;
    });
    hintCoordinate = {
      readingEndTimeLocal: hintRecord.readingEndTimeLocal,
      x: _luxon.DateTime.fromISO(hintRecord.readingEndTimeLocal, {
        zone: zone
      }).set({
        year: thisYear
      }).endOf('month').toISODate(),
      y: parseFloat(hintRecord.deliveredKwh) + maxValue * 0.05
    };
  }

  return /*#__PURE__*/_react["default"].createElement(_ScrollableXYPlot["default"], {
    hasNoData: hasNoData,
    roundedMaxValue: roundedMaxValue,
    tickValues: tickValues,
    enableOverflowX: true,
    widths: {
      mobile: mobileWidth,
      desktop: desktopWidth
    }
  }, /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    margin: {
      left: 0,
      right: 0,
      bottom: 60,
      top: 60
    },
    xType: "ordinal",
    yDomain: [0, roundedMaxValue],
    onMouseLeave: function onMouseLeave() {
      setNearestDataPoint(null);
    }
  }, !hasNoData && /*#__PURE__*/_react["default"].createElement(_reactVis.HorizontalGridLines, {
    tickValues: tickValues
  }), Object.keys(coordinateLinesByYear).map(function (year) {
    return /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
      color: lineColors[year],
      data: coordinateLinesByYear[year],
      style: {
        cursor: 'pointer',
        strokeWidth: 3
      }
    });
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    data: hoverCoordinates,
    onNearestX: function onNearestX(value) {
      var values = Object.keys(readingsYOY).map(function (year) {
        var reading = readingsYOY[year][value.x];

        if (reading) {
          reading.lineColor = lineColors[year];
        }

        return reading;
      });
      setNearestDataPoint(values);
    },
    style: {
      cursor: 'pointer',
      strokeWidth: 0
    }
  }), hintCoordinate && filteredNearestPoints.length > 0 && /*#__PURE__*/_react["default"].createElement(_reactVis.Crosshair, {
    values: [hintCoordinate],
    style: crosshairStyles
  }), filteredNearestPoints.length > 0 && filteredNearestPoints.map(function (hoverValue) {
    if (hoverValue) {
      return /*#__PURE__*/_react["default"].createElement(_reactVis.MarkSeries, {
        size: 4,
        fill: hoverValue.lineColor,
        stroke: hoverValue.lineColor,
        style: {
          pointerEvents: 'none'
        },
        data: [{
          x: _luxon.DateTime.fromISO(hoverValue.readingEndTimeLocal, {
            zone: zone
          }).set({
            year: thisYear
          }).endOf('month').toISODate(),
          y: hoverValue.deliveredKwh
        }]
      });
    }
  }), hintCoordinate && filteredNearestPoints.length > 0 && /*#__PURE__*/_react["default"].createElement(_reactVis.Hint, {
    align: {
      horizontal: 'right',
      vertical: 'top'
    },
    marginLeft: (0, _helpers.customerHintLeftMargin)(filteredNearestPoints[0], readingsYOY[thisYear]),
    marginRight: -79,
    value: hintCoordinate
  }, /*#__PURE__*/_react["default"].createElement(_Styles.HintBox, null, /*#__PURE__*/_react["default"].createElement(_Styles.HintHeader, null, _luxon.DateTime.fromISO(hintCoordinate.readingEndTimeLocal, {
    zone: zone
  }).toFormat('LLLL')), /*#__PURE__*/_react["default"].createElement(_Styles.HintBody, null, renderHint && renderHint(nearestDataPoint)))), /*#__PURE__*/_react["default"].createElement(_reactVis.Borders, {
    style: _chartStyles.borderStyle
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.XAxis, {
    style: {
      height: 100,
      line: {
        stroke: 'none'
      },
      text: {
        color: '#171717',
        fontSize: 14
      },
      ticks: {
        line: {
          stroke: 'none'
        }
      }
    },
    tickFormat: function tickFormat(isoDate) {
      return _luxon.DateTime.fromISO(isoDate, {
        zone: zone
      }).toFormat('LLL');
    }
  })));
};

CustomerMonthlyYOYChart.propTypes = {
  renderHint: _propTypes["default"].func,
  siteProductionMonthlyReadingsByYear: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({
    deliveredKwh: _propTypes["default"].string,
    readingEndTimeLocal: _propTypes["default"].string
  }))),
  lineColors: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  today: _propTypes["default"].string.isRequired,
  zone: _propTypes["default"].string,
  mobileWidth: _propTypes["default"].string,
  desktopWidth: _propTypes["default"].string
};
CustomerMonthlyYOYChart.defaultProps = {
  renderHint: undefined,
  siteProductionMonthlyReadingsByYear: [],
  zone: 'local',
  mobileWidth: '500px',
  desktopWidth: '100%'
};
var _default = CustomerMonthlyYOYChart;
exports["default"] = _default;